import { Capacitor } from '@capacitor/core'
import { mergeDocument, serverTimestamp } from './firestoreService'
import { getAppVersion } from '../utils/version'
import {
  SUPPORTED_VACCINE_RULE_ENGINE_VERSION,
  SUPPORTED_VACCINE_SCHEMA_VERSION,
} from '../config/vaccineSchema'

const INSTALLATION_ID_KEY = 'client_installation_id'
const INSTALLATION_FIRST_REPORT_KEY = 'client_version_first_report_at'
const LAST_REPORT_KEY = 'client_version_last_report_at'
const REPORT_INTERVAL_MS = 24 * 60 * 60 * 1000

function getInstallationId(): string {
  let id = localStorage.getItem(INSTALLATION_ID_KEY)
  if (!id) {
    id = globalThis.crypto?.randomUUID?.() ?? `${Date.now()}-${Math.random().toString(36).slice(2)}`
    localStorage.setItem(INSTALLATION_ID_KEY, id)
  }
  return id
}

export async function reportClientVersion(uid: string, dataVersion?: string): Promise<void> {
  const lastReportedAt = Number(localStorage.getItem(LAST_REPORT_KEY) ?? 0)
  if (Date.now() - lastReportedAt < REPORT_INTERVAL_MS) return

  const installationId = getInstallationId()
  let firstSeenAt = localStorage.getItem(INSTALLATION_FIRST_REPORT_KEY)
  if (!firstSeenAt) {
    firstSeenAt = new Date().toISOString()
    localStorage.setItem(INSTALLATION_FIRST_REPORT_KEY, firstSeenAt)
  }
  const { version, build } = await getAppVersion()
  await mergeDocument(`users/${uid}/clientInfo/${installationId}`, {
    uid,
    installationId,
    appVersion: version,
    buildNumber: build,
    platform: Capacitor.getPlatform(),
    schemaVersion: SUPPORTED_VACCINE_SCHEMA_VERSION,
    ruleEngineVersion: SUPPORTED_VACCINE_RULE_ENGINE_VERSION,
    dataVersion: dataVersion ?? null,
    firstSeenAt,
    lastSeenAt: serverTimestamp(),
  })
  localStorage.setItem(LAST_REPORT_KEY, String(Date.now()))
}
